import React, { useEffect, useState } from 'react';

export default function WixOAuthCallback() {
  const [status, setStatus] = useState('processing');
  const [errorDetail, setErrorDetail] = useState('');

  useEffect(() => {
    async function handleCallback() {
      const hash = window.location.hash.slice(1);
      const params = new URLSearchParams(hash);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');

      if (error) {
        setErrorDetail(`Wix error: ${error}`);
        setStatus('error');
        return;
      }

      if (!code || !state) {
        setErrorDetail(`Missing code or state. Hash: "${window.location.hash}"`);
        setStatus('error');
        return;
      }

      try {
        const res = await fetch('/api/auth/wix-oauth/exchange', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ code, state })
        });

        const data = await res.json().catch(() => ({}));

        if (res.ok) {
          window.location.href = '/';
        } else {
          setErrorDetail(`Exchange failed (${res.status}): ${data.error || 'unknown'}`);
          setStatus('error');
        }
      } catch (err) {
        setErrorDetail(`Network error: ${err.message}`);
        setStatus('error');
      }
    }

    handleCallback();
  }, []);

  if (status === 'error') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'sans-serif', textAlign: 'center' }}>
        <h1>CALMU GALLERY</h1>
        <p>ログインに失敗しました。</p>
        {errorDetail && <p style={{ fontSize: '0.8rem', color: '#666', maxWidth: '600px' }}>{errorDetail}</p>}
        <a href="https://www.calmu.design" style={{ color: '#426559', marginTop: '20px' }}>calmu.design に戻る</a>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
      <h1>CALMU GALLERY</h1>
      <p>ログイン処理中...</p>
    </div>
  );
}
